import { useLocation } from 'react-router-dom';

type BudgetIdLocationState = {
  budgetId?: string;
};

export const budgetIdPageParameter = {
  getLocationState: (budgetId: string): BudgetIdLocationState => ({
    budgetId,
  }),
  useBudgetId: (): string | undefined => {
    const { budgetId }: BudgetIdLocationState = useLocation().state ?? {};
    return budgetId;
  },
};
